import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/twelve-zodiac-signs/Index.vue')
const Ranking = () => import('../activity/twelve-zodiac-signs/Ranking.vue')
const Records = () => import('../activity/twelve-zodiac-signs/Records.vue')

export const indexRoute: RouteConfig = {
  path: '/twelve-zodiac-signs',
  name: 'twelve_zodiac_signs',
  component: Index,
  meta: {
    title: '十二星座运动牌',
  },
}

export const rankingRoute: RouteConfig = {
  path: '/twelve-zodiac-signs-ranking',
  name: 'twelve_zodiac_signs_ranking',
  component: Ranking,
  meta: {
    title: '星运值排行榜',
  },
}

export const recordsRoute: RouteConfig = {
  path: '/twelve-zodiac-signs-records',
  name: 'twelve_zodiac_signs_records',
  component: Records,
  meta: {
    title: '交换记录',
  },
}

export default [indexRoute, rankingRoute, recordsRoute]
